import { Code } from "./code";
import { Timer } from "./timer";

export class SecurityCode {
  constructor(element) {
    this.element = $(element);
    this.code = new Code($(element));
    this.validateButton = $("#securityCodeValidate", element);
    this.resendButton = $("#securityCodeResend", element);
    this.timer = new Timer($(".aw-timer:first", element));

    this.setTimerVisibility(false);
    this.setType("email");

    this.timer.element.on("finish", () => {
      this.setTimerVisibility(false);
    });

    this.validateButton.on("click", () => validateSecurityCode());

    this.resendButton.on("click", () => {
      if (this.timer.isRunning) {
        this.setTimerVisibility(true);
      } else {
        this.element.trigger("send");
      }
    });
  }

  startTimer() {
    if (!this.timer.isRunning) {
      this.timer.start(2);
    }
    this.setTimerVisibility(true);
  }

  setTimerVisibility(isVisible) {
    if (isVisible) {
      $(".aw-timer__resend-in", this.resendButton).removeClass("eui-d-none");
      $(".aw-timer__resend", this.resendButton).addClass("eui-d-none");
      this.resendButton.addClass("eui-btn--disabled");
      this.resendButton.attr("disabled", true);
      this.timer.showTimer();
    } else {
      $(".aw-timer__resend-in", this.resendButton).addClass("eui-d-none");
      $(".aw-timer__resend", this.resendButton).removeClass("eui-d-none");
      this.resendButton.removeClass("eui-btn--disabled");
      this.resendButton.removeAttr("disabled");
      this.timer.hideTimer();
    }
  }

  setType(type) {
    if (type === "email" || type === "sms") {
      $("[data-code-type]").hide();
      $(`[data-code-type=${type}]`).show();
    }
  }
}
